import React from 'react';
import './TransactionDetailsSkeleton.css';

const TransactionDetailsSkeleton = () => {
  return (
    <div className="transaction-details-skeleton-container">
      <div className="transaction-details-skeleton-breadcrumb" />

      <div className="transaction-details-skeleton-header">
        <div className="transaction-details-skeleton-title" />
        <div className="transaction-details-skeleton-badge" />
      </div>

      <div className="transaction-details-skeleton-date" />

      <div className="transaction-details-skeleton-section">
        <div className="transaction-details-skeleton-section-title" />
        <div className="transaction-details-skeleton-grid">
          <div className="transaction-details-skeleton-field">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
          <div className="transaction-details-skeleton-field">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
          <div className="transaction-details-skeleton-field">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value-badge" />
          </div>
          <div className="transaction-details-skeleton-field">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
          <div className="transaction-details-skeleton-field">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
          <div className="transaction-details-skeleton-field">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
        </div>
      </div>

      <div className="transaction-details-skeleton-section">
        <div className="transaction-details-skeleton-section-title" />
        <div className="transaction-details-skeleton-payment">
          <div className="transaction-details-skeleton-payment-row">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
          <div className="transaction-details-skeleton-payment-row">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
          <div className="transaction-details-skeleton-payment-row">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
          <div className="transaction-details-skeleton-payment-row">
            <div className="transaction-details-skeleton-label" />
            <div className="transaction-details-skeleton-value" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailsSkeleton;
